import { render, staticRenderFns } from "./PointCreditTechcoinConfirm.vue?vue&type=template&id=8a25b974"
import script from "./PointCreditTechcoinConfirm.vue?vue&type=script&lang=js"
export * from "./PointCreditTechcoinConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports